<template>
	<div id="content" class="content payment">
		<div class="container">
			<!-- 페이지 타이틀 -->
			<div class="page-title">
				<h2 class="tit">구매하기</h2>
			</div>

			<order-product :produc-list="producList" :total-cost="totalCost"></order-product>

			<order-form :order-info="orderInfo" :total-cost="totalCost"></order-form>

		</div>
	</div>
</template>
<script>
import OrderForm from "@/components/shop/order/orderForm";
import OrderProduct from "@/components/shop/order/orderProduct"
export default {
	name: "orderInfo",
	components: {OrderForm, OrderProduct},
	data() {
		var params = this.pageUtils.Params()
		return {
			params,
			producList: [],
			totalCost:0,

			orderInfo: new this.OrderInfoVO( this.getSessionProc() ),
		}
	},
	async created() {
		if(!this.isLogin())
			await !this.requireLogin(this, false)
		this.getProducts();
	},
	mounted() {
		this.getCoAccount();
	},
	methods: {

		getProducts() {
			console.log(this.productList)
			this.axiosCaller.get(this, this.APIs.SHOP_GOODS + "/getOrderProdc", {
				cidxs: this.$route.query.cidxs,
				gidx: this.$route.query.gidx,
			}, (res) => {
				if (res.data.status === "ok") {
					console.log(res.data)
					if (this.$route.query.cidxs !== undefined) {
						this.producList = res.data.producList;
						this.totalCost = res.data.total;
					} else if (this.$route.query.gidx !== undefined) {
						this.producList = res.data.producList;
						this.totalCost = res.data.producList[0].basePrice * this.$route.query.count;
					}
				} else {
					this.swalUtils.gritter("Error", res.msg, "error")
							.then(() => {
								if (document.location.href === document.referrer || document.referrer.indexOf("order_done") !== -1)
									location.href = "app/shop/goods";
								else
									location.href = document.referrer
							})
				}
			});
		},

		getCoAccount() {
			var orderInfo = this.orderInfo;
			this.$eventBus.$emit("startProgress")
			this.axiosCaller.get( this, this.APIs.CO_ACCOUNT + "/", {
				coCode: this.webUtils.getSubdomain(),
				coEmailId: this.getSessionProc().coEmailId,
			}, (res) => {
				this.$eventBus.$emit("doneProgress")
				const result = res.data
				// console.log('result.coAccountVO',result.coAccountVO)
				orderInfo.deliveryReceiverPhone = result.coAccountVO.phone;
				orderInfo.orderName = result.coAccountVO.userName;
				orderInfo.deliveryReceiverName = result.coAccountVO.userName;
				orderInfo.email = result.coAccountVO.coEmailId;
			})

		},
	},

}
</script>

<style scoped>

</style>
